<template>
    <div :class="className" :style="{height:eHeight,width:width}" />
</template>
<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

export default {
    mixins: [resize],
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '100%'
        },
        eHeight: {
            type: String,
            default: '100%'
        },
        autoResize: {
            type: Boolean,
            default: true
        },
        chartData: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            chart: null
        }
    },
    watch: {
        chartData: {
            deep: true,
            handler(val) {
                this.setOptions(val)
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart()
        })
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$el, 'macarons')
            this.setOptions(this.chartData || {})
        },
        setOptions(data) {
            let _this = this;
            this.chart.setOption({
                series: [{
                    type: 'gauge',
                    splitNumber: 5,
                    axisLine: {
                        lineStyle: {
                            color: [
                                [0.2, '#6fd505'],
                                [0.4, '#3edab7'],
                                [0.6, '#c01ceb'],
                                [0.8, '#6039fe'],
                                [1, '#12a7ff']
                            ]
                        }
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: _this.isbig ? '#AABEFF' : '#464646',
                        fontSize: 12,
                        distance: 0,
                        formatter: function(value) {
                            if (value === 80) {
                                return '优';
                            } else if (value === 60) {
                                return '中';
                            } else if (value === 40) {
                                return '良';
                            } else if (value === 20) {
                                return '差';
                            }
                        }
                    },
                    anchor: {
                        show: true,
                        showAbove: true,
                        size: 25,
                        itemStyle: {
                            borderWidth: 10
                        }
                    },
                    title: {
                        show: false
                    },
                    detail: {
                        fontSize: 30,
                        offsetCenter: [0, '85%'],
                        valueAnimation: true,
                        color: _this.isbig ? '#AABEFF' : '#333'
                    },
                    data: [{
                        name: "流转率",
                        title: {
                            show: true,
                            offsetCenter: [0, '58%'],
                            color: _this.isbig ? '#AABEFF' : ''
                        },
                        value: 88
                    }]
                }]
            })
        }
    }
}

</script>
